import { generateRandomNumberBetween } from "../number/random";

/**
 * Shuffles an array using the Fisher-Yates array shuffling algorithm
 * @param arr array to shuffle
 * @returns shuffled array
 */
export function getShuffledArray<Type>(arr: Type[]): Type[] {
	for (const [i] of arr.entries()) {
		const j = generateRandomNumberBetween(0, i - 1);
		const temp = arr[i];
		arr[i] = arr[j];
		arr[j] = temp;
	}
	return arr;
}
